/* ==========================================================================
   size-guide.js

   JS'in YALNIZCA ALTI İŞİ VAR. Başka iş yüklenmeyecek:
     1) drawer'ı <body>'ye taşımak
     2) sekme <-> panel eşlemesi
     3) seçili varyantla eşleşen sekmeyi açmak
     4) galeri slaytı: seçili ölçünün paneli + ölçü chip'leri (aynı senkron)
     5) renk satırı: renk başına PNG, varyant rengi seçmek ya da renk ürününe gitmek
     6) galeri slaytının yüksekliği (2026-10-25, satırlar sahnenin altında):
        sayfayı yerinde tutmak, kaydırıcıya yeniden ölçtürmek, thumb ya da
        chip sonrası satırları ekranda tutmak

   --------------------------------------------------------------------------
   NEDEN <body>'YE TAŞINIYOR
   <dialog> + showModal() top layer'a çıkar: sayfadaki hiçbir z-index
   (chat widget, app embed) üzerine çıkamaz ve arka plan otomatik inert olur.
   AMA transform uygulanmış bir ATA, position:fixed'i ve dialog
   konumlandırmasını bozar. Bu yüzden yüklemede dialog <body>'ye taşınır.

   --------------------------------------------------------------------------
   MutationObserver İÇİNDE SENKRON ÇAĞIRMA — CANLIDA YAŞANMIŞ HATA
   Observer bütün belgeyi izliyor (childList + subtree): tembel görseller,
   app embed'ler ve temanın kendi DOM güncellemeleri sürekli tetikliyor.
   Orada "seçili varyanta git" senkronu çağrılırsa KULLANICININ ELLE AÇTIĞI
   SEKME EZİLİR. Belirti: "sekmeye basıyorum, ilk birkaç geçiş geri dönüyor,
   sonra düzeliyor" (sayfa yerleşirken mutasyon sık, sonra seyrekleşir).

   Senkron TAM ÜÇ NOKTADA olur, başka yerde olmaz:
     1) drawer ilk kez bulunduğunda (bir kez)
     2) drawer açıldığında
     3) varyant GERÇEKTEN değiştiğinde
   Observer YALNIZCA tarama yapar.
   ========================================================================== */
(function () {
  'use strict';

  /* WeakSet için fallback YOK: <dialog>.showModal() destekleyen her
     tarayıcıda WeakSet de var. Hiç çalışmayacak ikinci bir kod yolu
     bırakmıyoruz. */
  var moved = new WeakSet();
  var rafPending = false;

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  /* Karşılaştırmada iki taraf da normalize edilir:
     trim + boşluk sıkıştırma + küçük harf. */
  function norm(value) {
    return String(value == null ? '' : value)
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  /* ------------------------------------------------------------------
     1) TAŞIMA
     ------------------------------------------------------------------ */
  function scan() {
    var dialogs = toArray(document.querySelectorAll('dialog[data-size-guide]'));

    for (var i = 0; i < dialogs.length; i++) {
      var d = dialogs[i];
      if (moved.has(d) || d.parentElement === document.body) {
        continue;
      }

      /* AJAX ile yeniden render edilen ürün blokları aynı id'li kopya
         bırakır; eskisi kaldırılmazsa drawer çoğalır. */
      if (d.id) {
        var all = toArray(document.querySelectorAll('dialog[data-size-guide]'));
        for (var j = 0; j < all.length; j++) {
          if (all[j] !== d && all[j].id === d.id) {
            all[j].remove();
          }
        }
      }

      document.body.appendChild(d);
      moved.add(d);

      /* Senkron noktası 1/3: drawer ilk kez bulunduğunda, BİR KEZ.
         Bu çağrı scan() içinde ama observer'ın kendisinde DEĞİL —
         yalnızca yeni bir dialog taşındığında çalışır. */
      sync(d);
    }
  }

  function scheduleScan() {
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(function () {
      rafPending = false;
      scan();
    });
  }

  /* ------------------------------------------------------------------
     2) SEKME <-> PANEL
     ------------------------------------------------------------------ */
  function panelOf(dialog, tab) {
    var id = tab.getAttribute('aria-controls');
    if (!id) return null;
    /* getElementById kaçış gerektirmez; querySelector'a düşersek id'yi
       CSS.escape ile kaçırmak ZORUNLU (id'de Liquid'den gelen karakterler
       olabilir). */
    var el = document.getElementById(id);
    if (el) return el;
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return dialog.querySelector('#' + window.CSS.escape(id));
    }
    return null;
  }

  function activate(dialog, tab) {
    var tabs = toArray(dialog.querySelectorAll('[data-size-guide-tab]'));
    for (var i = 0; i < tabs.length; i++) {
      var on = tabs[i] === tab;
      tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
      tabs[i].tabIndex = on ? 0 : -1;
      var panel = panelOf(dialog, tabs[i]);
      if (panel) panel.hidden = !on;
    }
  }

  /* ------------------------------------------------------------------
     3) SENKRON
     CANLI INPUT DEĞERİNE karşı yapılır, Liquid'de değil: varyant AJAX ile
     değiştiğinde Liquid'den gelen "seçili" bilgisi bayatlar.
     ------------------------------------------------------------------ */
  function selectedValues(el) {
    var scopeId = el.getAttribute('data-size-guide-scope');
    var scope = scopeId ? document.getElementById(scopeId) : null;
    if (!scope) return [];

    var values = [];
    toArray(
      scope.querySelectorAll(
        '.variant-input-wrap input[type="radio"]:checked, input[data-variant-input]:checked'
      )
    ).forEach(function (input) {
      values.push(input.value);
    });
    toArray(
      scope.querySelectorAll('.variant-input-wrap select[data-index], select[data-variant-input]')
    ).forEach(function (select) {
      values.push(select.value);
    });

    return values.map(norm);
  }

  function sync(dialog) {
    var normalized = selectedValues(dialog);
    if (!normalized.length) return;

    var tabs = toArray(dialog.querySelectorAll('[data-size-guide-tab]'));

    for (var i = 0; i < tabs.length; i++) {
      var raw = norm(tabs[i].getAttribute('data-raw-value'));
      if (raw && normalized.indexOf(raw) !== -1) {
        activate(dialog, tabs[i]);
        return;
      }
    }
  }

  /* Galeri slaytı (size-guide.liquid, sg_mode 'slide') yalnızca seçili
     ölçünün panelini gösterir; drawer'la aynı üç noktada senkronlanır. */
  function syncSlide(slide) {
    var normalized = selectedValues(slide);
    if (!normalized.length) return;

    var panels = toArray(slide.querySelectorAll('[data-size-guide-panel]'));
    var match = null;
    for (var i = 0; i < panels.length; i++) {
      var raw = norm(panels[i].getAttribute('data-raw-value'));
      if (raw && normalized.indexOf(raw) !== -1) {
        match = panels[i];
        break;
      }
    }
    /* Çizilemeyen bir ölçü seçiliyse son çizim kalır, hiçbir chip seçili görünmez. */
    if (match) {
      panels.forEach(function (panel) {
        panel.hidden = panel !== match;
      });
    }
    var checkedRaw = match ? norm(match.getAttribute('data-raw-value')) : '';

    /* Chip'ler radio grubu: Tab seçili chip'e gelir (roving tabindex).
       Diğer seçeneklerle olmayan ölçü buy box'taki gibi üstü çizili. */
    var chips = toArray(slide.querySelectorAll('[data-size-guide-chip]'));
    var anyChecked = false;
    chips.forEach(function (chip) {
      var on = norm(chip.getAttribute('data-size-guide-chip')) === checkedRaw;
      if (on) anyChecked = true;
      chip.setAttribute('aria-checked', on ? 'true' : 'false');
      chip.tabIndex = on ? 0 : -1;
      var input = chipInput(slide, chip);
      chip.classList.toggle('is-unavailable', !!(input && input.classList.contains('disabled')));
    });
    if (!anyChecked && chips[0]) chips[0].tabIndex = 0;

    var row = slide.querySelector('.size-guide-slide__chips');
    if (row) {
      checkedInView(row);
      if (rowObserver && !observedRows.has(row)) {
        observedRows.add(row);
        rowObserver.observe(row);
      }
    }
  }

  /* Chip'in buy box'taki karşılığı: aynı ürün bölümündeki Boyut radio'su. */
  function chipInput(slide, chip) {
    var scopeId = slide.getAttribute('data-size-guide-scope');
    var scope = scopeId ? document.getElementById(scopeId) : null;
    if (!scope) return null;
    var want = norm(chip.getAttribute('data-size-guide-chip'));
    var inputs = toArray(scope.querySelectorAll('.variant-input-wrap input[type="radio"], input[data-variant-input]'));
    for (var i = 0; i < inputs.length; i++) {
      if (norm(inputs[i].value) === want) return inputs[i];
    }
    return null;
  }

  /* Seçili chip satır kayınca görünür kalsın. Slayt ekran dışındayken
     tema onu display:none yapar (layout yok); ResizeObserver satır
     göründüğünde bunu tekrar çalıştırır. */
  function checkedInView(row) {
    var chip = row.querySelector('[aria-checked="true"]');
    if (!chip || row.scrollWidth <= row.clientWidth) return;
    var left = chip.offsetLeft;
    if (left < row.scrollLeft || left + chip.offsetWidth > row.scrollLeft + row.clientWidth) {
      row.scrollLeft = left - 16;
    }
  }

  var rowObserver = typeof ResizeObserver === 'function'
    ? new ResizeObserver(function (entries) {
        entries.forEach(function (entry) { checkedInView(entry.target); });
      })
    : null;
  var observedRows = new WeakSet();

  function syncSlides() {
    toArray(document.querySelectorAll('[data-size-guide-slide]')).forEach(syncSlide);
  }

  function syncAll() {
    toArray(document.querySelectorAll('dialog[data-size-guide]')).forEach(sync);
    syncSlides();
    /* Tema tükenmiş ölçüleri change olayından SONRA işaretliyor; bir kare sonra tekrar oku. */
    requestAnimationFrame(syncSlides);
  }

  /* Chip: buy box'taki Boyut radio'sunu seçer ve change tetikler; fiyat, stok,
     URL normal varyant yolundan gelir. theme.js yalnızca ölçü değiştiyse
     galeriyi bu slaytta tutar. */
  document.addEventListener('click', function (event) {
    var chip = event.target && event.target.closest ? event.target.closest('[data-size-guide-chip]') : null;
    if (!chip) return;
    var slide = chip.closest('[data-size-guide-slide]');
    var input = slide && chipInput(slide, chip);
    if (!input || input.checked) return;
    input.checked = true;
    window.__sgKeepSlide = Date.now();
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Yön tuşları chip'ler arasında gezer ve ölçüyü seçer (radio grubu);
     Home / End uçlara gider. Capture fazı: galeri de yön tuşlarını dinliyor. */
  document.addEventListener('keydown', function (event) {
    var chip = event.target && event.target.closest ? event.target.closest('[data-size-guide-chip], [data-sg-look]') : null;
    if (!chip) return;
    var all = toArray(chip.parentNode.querySelectorAll(chip.hasAttribute('data-sg-look') ? '[data-sg-look]' : '[data-size-guide-chip]'));
    var i = all.indexOf(chip);
    var next = null;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = all[(i + 1) % all.length];
    else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = all[(i - 1 + all.length) % all.length];
    else if (event.key === 'Home') next = all[0];
    else if (event.key === 'End') next = all[all.length - 1];
    if (!next) return;
    event.preventDefault();
    event.stopPropagation();
    next.focus();
    next.click();
  }, true);

  /* Renk satırı (snippets/size-guide-looks): renk başına bir PNG. Varyant
     rengi buy box'taki renk radio'sunu seçer (theme.js galeriyi slaytta
     tutar, data-sg-stay); ayrı ürün olan renkler çizimi hemen değiştirir,
     sonra o ürünü aynı ölçü seçili ve galeri bu slaytta açılacak şekilde açar. */
  function looksOf(slide) {
    if (!slide.__sgLooks) {
      var el = slide.querySelector('script[data-sg-looks]');
      try { slide.__sgLooks = el ? JSON.parse(el.textContent) : null; } catch (e) { slide.__sgLooks = null; }
    }
    return slide.__sgLooks;
  }

  function swapPng(slide, look) {
    var scopeId = slide.getAttribute('data-size-guide-scope');
    var roots = [slide];
    toArray(document.querySelectorAll('dialog[data-size-guide]')).forEach(function (d) {
      if (d.getAttribute('data-size-guide-scope') === scopeId) roots.push(d);
    });
    roots.forEach(function (root) {
      toArray(root.querySelectorAll('img[data-sg-png]')).forEach(function (img) {
        img.srcset = look.s + ' 600w, ' + look.l + ' 1200w';
        img.src = look.s;
      });
    });
  }

  function markLook(slide, index) {
    toArray(slide.querySelectorAll('[data-sg-look]')).forEach(function (chip) {
      var on = chip.getAttribute('data-sg-look') === String(index);
      chip.setAttribute('aria-checked', on ? 'true' : 'false');
      chip.tabIndex = on ? 0 : -1;
    });
  }

  function scopeInputs(slide, selector) {
    var scopeId = slide.getAttribute('data-size-guide-scope');
    var scope = scopeId ? document.getElementById(scopeId) : null;
    return scope ? toArray(scope.querySelectorAll(selector)) : [];
  }

  function colourInputs(slide, data) {
    return scopeInputs(slide, 'input[data-index="option' + (data.opt + 1) + '"]');
  }

  /* Varyant renkleri buy box'ı takip eder. */
  function syncLooks() {
    toArray(document.querySelectorAll('[data-size-guide-slide]')).forEach(function (slide) {
      var data = looksOf(slide);
      if (!data || data.mode !== 'variant') return;
      var checked = colourInputs(slide, data).filter(function (i) { return i.checked; })[0];
      if (!checked) return;
      for (var i = 0; i < data.looks.length; i++) {
        if (data.looks[i].v === checked.value) {
          markLook(slide, i);
          swapPng(slide, data.looks[i]);
          return;
        }
      }
    });
  }

  document.addEventListener('variant:change', syncLooks);
  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches && event.target.matches('[data-variant-input], .variant-input-wrap input')) syncLooks();
  });

  document.addEventListener('click', function (event) {
    var chip = event.target && event.target.closest ? event.target.closest('[data-sg-look]') : null;
    if (!chip) return;
    var slide = chip.closest('[data-size-guide-slide]');
    var data = slide && looksOf(slide);
    var look = data && data.looks[parseInt(chip.getAttribute('data-sg-look'), 10)];
    if (!look) return;
    if (data.mode === 'variant') {
      var input = colourInputs(slide, data).filter(function (i) { return i.value === look.v; })[0];
      if (!input || input.checked) return;
      input.checked = true;
      window.__sgKeepSlide = Date.now();
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    if (look.c) return;
    markLook(slide, chip.getAttribute('data-sg-look'));
    swapPng(slide, look);
    /* Seçili ölçü: ölçü chip'lerinin değerlerinden buy box'ta işaretli olan. */
    var sizes = toArray(slide.querySelectorAll('[data-size-guide-chip]')).map(function (c) {
      return norm(c.getAttribute('data-size-guide-chip'));
    });
    var size = scopeInputs(slide, '.variant-input-wrap input[type="radio"], input[data-variant-input]').filter(function (i) {
      return i.checked && sizes.indexOf(norm(i.value)) !== -1;
    })[0];
    var id = size && look.z ? look.z[size.value] : null;
    window.location.href = look.u + (id ? '?variant=' + id : '') + '#size-guide';
  });

  /* Renk chip'inden gelindiyse (#size-guide) galeriyi rehber slaytında aç. */
  function openFromHash() {
    if (window.location.hash !== '#size-guide') return;
    var tries = 0;
    (function go() {
      var thumb = document.querySelector('.product__thumb--size-guide');
      var ready = document.querySelector('.product-slideshow.flickity-enabled');
      if (thumb && ready) { thumb.click(); return; }
      if (++tries < 40) setTimeout(go, 100);
    })();
  }

  /* Chip satırı galerinin içinde: oradaki basma/kaydırma slaytları sürüklemesin. */
  ['pointerdown', 'mousedown', 'touchstart'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      if (event.target && event.target.closest && event.target.closest('.size-guide-slide__chips')) {
        event.stopPropagation();
      }
    }, { capture: true, passive: true });
  });

  /* ------------------------------------------------------------------
     AÇ / KAPAT
     ------------------------------------------------------------------ */
  function openDialog(dialog) {
    /* Senkron noktası 2/3 */
    sync(dialog);

    dialog.classList.remove('size-guide--fallback');

    if (typeof dialog.showModal === 'function') {
      if (dialog.open) {
        /* Açık bir dialog'da showModal() InvalidStateError atar.
           Modal OLMAYAN bir <dialog> top layer'a girmez: tarayıcı ona
           position:absolute verir, arka plan kararmaz, panel sayfanın
           akışına göre konumlanır. O yüzden önce close().
           :modal desteklenmiyorsa modal VARSAYILIR, dokunulmaz. */
        var isModal = true;
        try {
          isModal = dialog.matches(':modal');
        } catch (e) {
          isModal = true;
        }
        if (isModal) return;
        try {
          dialog.close();
        } catch (e) {}
      }
      try {
        dialog.showModal();
        return;
      } catch (e) {}
    }

    dialog.setAttribute('open', '');
    dialog.classList.add('size-guide--fallback');
  }

  function closeDialog(dialog) {
    /* Fallback sınıfı HER İKİ dalda da temizlenir. Fallback ile açılmış
       bir panel dialog.close() dalından geçerse sınıf üzerinde kalır ve
       sonraki modal açılışta ::backdrop üzerine İKİNCİ bir karartma biner. */
    dialog.classList.remove('size-guide--fallback');

    if (typeof dialog.close === 'function' && dialog.open) {
      try {
        dialog.close();
        return;
      } catch (e) {}
    }
    dialog.removeAttribute('open');
  }

  /* ------------------------------------------------------------------
     OLAYLAR
     ------------------------------------------------------------------ */

  /* Tetikleyici ölçü seçeneğinin <label> satırında duruyor. CAPTURE
     fazında yakalanıp stopPropagation yapılmazsa tıklama label'ı aktive
     eder ve VARYANT SEÇİMİNİ DEĞİŞTİRİR. preventDefault de gerekir. */
  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target && event.target.closest
        ? event.target.closest('[data-size-guide-open]')
        : null;
      if (!trigger) return;

      var id = trigger.getAttribute('data-size-guide-open');
      var dialog = id ? document.getElementById(id) : null;
      if (!dialog) return;

      event.preventDefault();
      event.stopPropagation();
      openDialog(dialog);
    },
    true
  );

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var closer = target.closest('[data-size-guide-close]');
    if (closer) {
      var owner = closer.closest('dialog[data-size-guide]');
      if (owner) {
        event.preventDefault();
        closeDialog(owner);
      }
      return;
    }

    var tab = target.closest('[data-size-guide-tab]');
    if (tab) {
      var dlg = tab.closest('dialog[data-size-guide]');
      if (dlg) {
        event.preventDefault();
        activate(dlg, tab);
      }
      return;
    }

    /* Backdrop: hedef dialog'un KENDİSİYSE (içeriğe değil) kapat. */
    if (target.matches && target.matches('dialog[data-size-guide]')) {
      closeDialog(target);
    }
  });

  document.addEventListener('keydown', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var tab = target.closest('[data-size-guide-tab]');
    if (tab && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) {
      var dialog = tab.closest('dialog[data-size-guide]');
      if (!dialog) return;
      var tabs = toArray(dialog.querySelectorAll('[data-size-guide-tab]'));
      var index = tabs.indexOf(tab);
      if (index === -1) return;

      event.preventDefault();
      var next = event.key === 'ArrowRight' ? index + 1 : index - 1;
      if (next < 0) next = tabs.length - 1;
      if (next >= tabs.length) next = 0;
      activate(dialog, tabs[next]);
      tabs[next].focus();
      return;
    }

    /* Fallback dalında Esc'i tarayıcı kapatmaz. */
    if (event.key === 'Escape') {
      var open = document.querySelector('dialog[data-size-guide].size-guide--fallback[open]');
      if (open) {
        event.preventDefault();
        closeDialog(open);
      }
    }
  });

  /* Native 'close' BUBBLE ETMEZ — capture fazında dinlenir. */
  document.addEventListener(
    'close',
    function (event) {
      var target = event.target;
      if (target && target.matches && target.matches('dialog[data-size-guide]')) {
        target.classList.remove('size-guide--fallback');
      }
    },
    true
  );

  /* Senkron noktası 3/3: varyant GERÇEKTEN değiştiğinde. */
  document.addEventListener('variant:change', syncAll);

  /* 'change' dinleyicisi DARALTILIR. document üzerinde çıplak bir
     dinleyici sayfadaki alakasız her select/input'u (adet, bülten, app)
     yakalar ve kullanıcının açtığı sekmeyi sıfırlar. */
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.matches) return;
    if (
      !target.matches(
        '[data-variant-input], .variant-input-wrap input, .variant-input-wrap select'
      )
    ) {
      return;
    }
    syncAll();
  });

  /* ------------------------------------------------------------------
     BAŞLAT
     ------------------------------------------------------------------ */
  /* Henüz kaydırılmamış satır (sayfa büyük bir ölçü ya da renkle açıldı):
     slayt görününce seçili chip'i gösterir. */
  var rowSeen = typeof IntersectionObserver === 'function'
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { if (entry.isIntersecting) checkedInView(entry.target); });
      })
    : null;
  function watchRows() {
    if (!rowSeen) return;
    toArray(document.querySelectorAll('[data-size-guide-slide] .size-guide-slide__chips')).forEach(function (row) { rowSeen.observe(row); });
  }

  /* ------------------------------------------------------------------
     6) GALERİ SLAYTININ YÜKSEKLİĞİ
     Slayt fotoğraflardan uzun (satırlar sahnenin altında, 2026-10-25, IWA'daki
     gibi) ve galeri seçili slaytın yüksekliğini alır (adaptiveHeight).
     ------------------------------------------------------------------ */
  /* Galeri, görünür alanın üstündeyken büyürse (ör. buy box'ta seçilen ölçü
     galeriyi slayta götürür) sayfa ziyaretçinin parmağının altında kayardı.
     Chrome ve Firefox bunu kendisi önler (scroll anchoring; IWA'da ikinci kez
     düzeltmek sayfayı iki kat kaydırdı), o yüzden yalnızca overflow-anchor'ı
     olmayan tarayıcılarda fark kadar kaydırılır. Galerinin kendisindeki
     kaydırma ya da dokunuşa karışılmaz: orada ziyaretçi slayta bakıyordur. */
  var galleryTouch = false;
  ['pointerdown', 'touchstart'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      var t = event.target;
      galleryTouch = !!(t && t.closest && t.closest('.product__photos'));
    }, { capture: true, passive: true });
  });

  var observedViewports = typeof WeakSet === 'function' ? new WeakSet() : null;
  function keepPageStill() {
    if (typeof ResizeObserver !== 'function' || !observedViewports) return;
    if (window.CSS && CSS.supports && CSS.supports('overflow-anchor', 'auto')) return;
    toArray(document.querySelectorAll('[data-size-guide-slide]')).forEach(function (slide) {
      var viewport = slide.closest('.flickity-viewport');
      if (!viewport || observedViewports.has(viewport)) return;
      observedViewports.add(viewport);
      var last = viewport.getBoundingClientRect().height;
      new ResizeObserver(function () {
        var rect = viewport.getBoundingClientRect();
        var delta = rect.height - last;
        last = rect.height;
        if (!delta || rect.top >= 0 || galleryTouch) return;
        var html = document.documentElement;
        var was = html.style.scrollBehavior;
        html.style.scrollBehavior = 'auto';
        window.scrollBy(0, delta);
        html.style.scrollBehavior = was;
      }).observe(viewport);
    });
  }

  /* Kaydırıcı hücreleri bir kez ölçer; masaüstünde galeri sütunu ondan sonra
     birkaç piksel genişler (EN 1440: 553 ölçüldü, 560 yerleşti). Fotoğraflarda
     görünmez; bu slaytta saklanan yükseklik oda fotoğrafı + banttan kısa kalıp
     bandın altını kesiyordu. Slaytın gerçek boyu ölçülenden ayrılınca kaydırıcı
     yeniden ölçer; Flickity hareket halindeyken resize()'ı yok sayar (#size-guide
     açılışı bu hücreye kayar), o zaman durmasını bekler. */
  var measuredCells = typeof WeakSet === 'function' ? new WeakSet() : null;
  function remeasure() {
    if (typeof ResizeObserver !== 'function' || !window.Flickity || !measuredCells) return;
    toArray(document.querySelectorAll('.product-main-slide--size-guide')).forEach(function (cell) {
      var el = cell.closest('.flickity-enabled');
      var flkty = el && Flickity.data(el);
      if (!flkty || measuredCells.has(cell)) return;
      measuredCells.add(cell);
      function stale() {
        var c = flkty.getCell(cell);
        return !!(c && c.size) && (Math.abs(c.size.outerWidth - cell.offsetWidth) > 1 || Math.abs(c.size.outerHeight - cell.offsetHeight) > 1);
      }
      function refit() {
        if (!stale()) return;
        if (flkty.isAnimating || flkty.isDragging) {
          flkty.once('settle', refit);
          return;
        }
        flkty.resize();
      }
      new ResizeObserver(refit).observe(cell);
    });
  }

  /* Satırlar ekranda: ziyaretçi slaytı thumb'dan açınca ya da üstünde bir chip
     seçince sayfa, satırların görünür alanın altından 8px yukarıda (yapışkan
     sepet çubuğu görünüyorsa onun üstünde; snippets/sticky-add-to-cart,
     .is-visible) durması için gereken kadar kayar. Galerinin yükseklik
     değişiminden sonra. Buy box seçiminde değil: ziyaretçi o an buy box'ı
     okuyor. */
  function revealRows(slide) {
    window.setTimeout(function () {
      var cell = slide.closest('.product-main-slide');
      if (cell && !cell.classList.contains('is-selected')) return;
      var under = slide.querySelector('.size-guide-slide__under');
      if (!under) return;
      var bar = document.querySelector('.sticky-add-to-cart.is-visible');
      var barH = bar ? bar.getBoundingClientRect().height : 0;
      var over = under.getBoundingClientRect().bottom - (window.innerHeight - barH - 8);
      if (over <= 1) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollBy({ top: Math.ceil(over), behavior: reduce ? 'auto' : 'smooth' });
    }, 450);
  }

  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || !t.closest) return;
    var slide = null;
    if (t.closest('[data-size-guide-slide] [role="radio"]')) {
      slide = t.closest('[data-size-guide-slide]');
    } else if (t.closest('.product__thumb--size-guide')) {
      var photos = t.closest('[data-product-images]');
      slide = photos && photos.querySelector('[data-size-guide-slide]');
    }
    if (slide) revealRows(slide);
  });

  function start() {
    scan();
    watchRows();
    openFromHash();
    toArray(document.querySelectorAll('[data-size-guide-slide]')).forEach(syncSlide);
    /* kaydırıcı slaytları kendi viewport'una bundan sonra sarabilir */
    keepPageStill();
    remeasure();
    window.addEventListener('load', function () {
      keepPageStill();
      remeasure();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* Observer YALNIZCA tarar. Senkron ÇAĞIRMAZ — yukarıdaki nota bak. */
  if (typeof MutationObserver === 'function') {
    new MutationObserver(scheduleScan).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();
